import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import TermsPage from './TermsPage';
import './TermsPage.less';

export const prefix = 'bm-p-terms';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: TermsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
